import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import OutboundList from './pages/OutboundList';
import OutboundDetail from './pages/OutboundDetail';
import ProductDetail from './pages/ProductDetail';
import ScanPage from './pages/ScanPage';
import ScanVerify from './pages/ScanVerify';

function App() {
  return (
    <AuthProvider>
      <div className="pad-container">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route 
            path="/dashboard" 
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/outbound" 
            element={
              <ProtectedRoute>
                <OutboundList />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/outbound/:id" 
            element={
              <ProtectedRoute>
                <OutboundDetail />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/product/:id" 
            element={
              <ProtectedRoute>
                <ProductDetail />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/scan" 
            element={
              <ProtectedRoute>
                <ScanPage />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/scan-verify" 
            element={
              <ProtectedRoute>
                <ScanVerify />
              </ProtectedRoute>
            } 
          />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </div>
    </AuthProvider>
  );
}

export default App;